module.exports = __webpack_public_path__ + "img/action_1st.9f7bdeb.png";